import * as Schema from "effect/Schema";

import { PortSchema } from "./baseSchemas.ts";

export const ManagedEnvironmentBootstrap = Schema.Struct({
  noBrowser: Schema.Boolean,
  port: PortSchema,
  maitoHome: Schema.String,
  host: Schema.String,
  environmentBootstrapToken: Schema.String,
  otlpTracesUrl: Schema.optional(Schema.String),
  otlpMetricsUrl: Schema.optional(Schema.String),
});

export type ManagedEnvironmentBootstrap = typeof ManagedEnvironmentBootstrap.Type;
